import cn from 'classnames';

import { useInt } from 'hooks/useInt';

interface Props {
  size?: 'sm' | 'md' | 'lg';
  title?: string;
}

export const SelectLoader = ({ size = 'lg', title }: Props) => {
  const { t } = useInt();

  return <div className={cn('gdb-select-loader', `gdb-select-loader--${size}`)}>{title ?? t('Loading')}</div>;
};
